export const reactSelectStyle = {
  container: (provided: any) => ({
    ...provided,
    height: '100%',
    width: '200px',
  }),
  control: (provided: any) => ({
    ...provided,
    height: '100%',
    width: '200px',
    borderRadius: '8px',
  }),
};

/**
 * React-select input style
 * @date 2024/03/11
 */
export const selectCustomStyle = {
  control: (baseStyles: any, state: any) => ({
    ...baseStyles,
    borderWidth: state.isFocused ? 0 : 1,
    borderRadius: 8,
  }),
  option: (baseStyles: any) => ({
    ...baseStyles,
    borderBottom: '1px solid #EEEEEE',
  }),
};

export const selectInGroup = {
  control: (baseStyles: any, state: any) => ({
    ...baseStyles,
    borderWidth: state.isFocused ? 0 : 1,
    borderBottomLeftRadius: 8,
    borderTopLeftRadius: 8,
    borderBottomRightRadius: 0,
    borderTopRightRadius: 0,
    paddingTop: 4,
    paddingBottom: 4,
  }),
  option: (baseStyles: any) => ({
    ...baseStyles,
    borderBottom: '1px solid #EEEEEE',
  }),
};
